import LinkButton from '~/components/button/LinkButton';
import Page from '~/components/layout/page/Page';
import { ClaimType } from '~/utils/constants';
import { useLoaderData } from './newRequest';

export default function NewRequestPage() {
  const {
    claimTypeSelectionDetailText,
    returnProgramName,
    warrantyProgramName,
  } = useLoaderData();

  return (
    <Page.Root title="Which of the following best fits your needs?">
      <p>{claimTypeSelectionDetailText}</p>
      <div className="flex w-full flex-col gap-2 md:flex-row md:gap-4">
        <LinkButton
          className="w-full"
          variant="filled"
          to={`../${ClaimType.return.toLowerCase()}`}
        >
          {returnProgramName}
        </LinkButton>
        <LinkButton
          className="w-full"
          variant="filled"
          to={`../${ClaimType.warranty.toLowerCase()}`}
        >
          {warrantyProgramName}
        </LinkButton>
      </div>
    </Page.Root>
  );
}
